/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/** Custom Maestroo code (Theme developer) to fix iOS 13 issues */
(function() {
  var touchingCarousel = false,
      touchStartCoords;

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function(e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

      }, {passive: false});

  document.addEventListener("DOMContentLoaded", function(event) { 
    var bannerImageElement = document.querySelector('.custom-page__Image');
    if (bannerImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
      var page_parallaxInstance = new Rellax('.custom-page__Image', {
        speed: -7,
        center: false,
        round: true
      });
    }
  });

  var headerImageElement = document.querySelector('.PageHeader--custom-contact-us .PageHeader__ImageWrapper');

  if (headerImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
    this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
      speed: -7,
      center: false,
      round: true
    });
  }

  document.addEventListener("DOMContentLoaded", function(e) {

//     var initFlickity = true;
//     function responseContactUsFlickity() {

//       var visit_us_blocks = document.querySelectorAll('#section-custom-contact-us-visit .Timeline__Item');
//       if(visit_us_blocks) {
//         var windowWidth = window.innerWidth;
//         if(windowWidth < 641) {
//           if(initFlickity ) {
//             initFlickity = false;
//             for(var i=0;i < visit_us_blocks.length;i++) {
//               var el = visit_us_blocks[i];

//               var flkty = new Flickity( el, {
//                 cellAlign: 'left',
//                 contain: true,
//                 wrapAround: true,
//                 prevNextButtons: false,
//                 pageDots: false
//               });

//             }
//           }
//         } else {
//           if(initFlickity == false) {
//             initFlickity = true;
//             for(var y=0;y < visit_us_blocks.length;y++) {
//               var el = visit_us_blocks[y];
//               var flkty = Flickity.data(el);
//               flkty.destroy();
//             }
//           }
//         }
//       }
//     }
    //     responseContactUsFlickity();

    //     window.addEventListener('resize',responseContactUsFlickity);  


    var visitUs_Slider = document.querySelector('#showrooms .Timeline__ListItem');

    if(visitUs_Slider) {
      var slidesQty = +visitUs_Slider.getAttribute('data-qty-slides');

      if (slidesQty > 1) {
        var flkty = new Flickity(visitUs_Slider, {
          "prevNextButtons": true,
          "pageDots": false,
          "contain": true,
          "cellAlign": "center",
          "dragThreshold": 8,
          "groupCells": true,
          "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
        });
      }
    }

  });

})();


let links = document.links;

        for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
          if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noopener';
          }
        }